import cn from 'classnames';
import React, { FC, PropsWithChildren } from 'react';
import Navbar from 'students/views/shared/components/Navbar';
import PageWithBg from 'students/views/shared/components/PageWithBg';
import { FixedSurfaceProvider } from 'students/views/shared/providers/Theme';
import { SPageContainer, SPageWrapper } from 'students/views/shared/styled';
import { NavBar as Sidebar } from './Member/components/navigation';

export interface IPage {
  background?: string;
  gradient?: string;
  bgImage?: string;
  bgSize?: string;
  bgPosition?: string;
  hasImageOverlay?: boolean;
  overlayColor?: string;
  style?: React.CSSProperties;
  hasNavbar?: boolean;
  hasSidebar?: boolean;
  className?: string;
  noPadding?: boolean;
  backPath?: string;
  PageNavigation?: React.ReactNode;
}

const Page: FC<PropsWithChildren<IPage>> = ({
  children,
  background,
  gradient,
  bgImage,
  bgSize,
  bgPosition,
  hasImageOverlay,
  overlayColor,
  hasNavbar,
  hasSidebar,
  style,
  className,
  noPadding,
  backPath,
  PageNavigation
}) => {
  const hasInvariantBg = !!(background || gradient || bgImage);

  return (
    <FixedSurfaceProvider active={hasInvariantBg}>
      <PageWithBg
        gradient={gradient}
        solidColor={background}
        bgImage={bgImage}
        bgSize={bgSize}
        bgPosition={bgPosition}
        hasImageOverlay={hasImageOverlay}
        overlayColor={overlayColor}
        style={style}
      >
        {!!hasNavbar && <Navbar backTo={backPath} />}

        <div className="ln-flex-1 ln-min-w-[320px] ln-max-w-screen ln-flex ln-flex-col xl:ln-flex-row [&>main]:ln-flex-1">
          {!!hasSidebar && <Sidebar mobileVariant="small" />}

          <SPageWrapper>
            {PageNavigation}

            <SPageContainer className={cn(className)} noPadding={noPadding}>
              {children}
            </SPageContainer>
          </SPageWrapper>
        </div>
      </PageWithBg>
    </FixedSurfaceProvider>
  );
};

export default Page;
